/**
 * Merge a freshly read message list into the previous one, keeping unchanged rows' objects.
 * Every write must stamp `updatedAt`. See .claude/context/message-history.md
 */
export const reconcileMessages = (prev, incoming) => {
  const prevById = new Map(prev.map((msg) => [msg.id, msg]));
  let changed = incoming.length !== prev.length;
  const next = incoming.map((inc, index) => {
    const old = prevById.get(inc.id);
    if (old && old.updatedAt === inc.updatedAt) {
      // Same content; reuse the prior reference. Still flag a change if the row
      // moved position, so React re-keys correctly.
      if (old !== prev[index]) changed = true;
      return old;
    }
    changed = true;
    return inc;
  });
  return changed ? next : prev;
};
